import { useMemo } from 'react';

import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { IFilterDefinition } from '@evinced-private/ui-common';

import { DEFAULT_DATE_RANGE_DAYS } from 'src/apps/dashboard/constants/DashboardFiltersDefinitions';
import { useEffectiveFilters } from 'src/apps/dashboard/helpers/FilterHelpers';
import { getDashboardData } from 'src/apps/dashboard/services/dashboard/DashboardService';
import { DashboardDataResult } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';
import { REFETCH_INTERVAL } from 'src/common/consts/QueryConfigs';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { DASHBOARD_DATA } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';

export const useDashboardDataQuery = (
	filters?: IFilterOptions,
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard,
	filterDefinitions?: IFilterDefinition[]
): UseQueryResult<DashboardDataResult, Error> => {
	const effectiveFilters = useEffectiveFilters(filters, filterDefinitions);

	const days = useMemo(() => {
		const dateRangeValue = effectiveFilters?.dateRange?.[0]?.value;
		return dateRangeValue ? Number(dateRangeValue) : DEFAULT_DATE_RANGE_DAYS;
	}, [effectiveFilters]);

	return useQuery<DashboardDataResult, Error>({
		queryKey: [DASHBOARD_DATA, days, effectiveFilters, labelsExcludedFromDashboard],
		queryFn: () => getDashboardData(days, effectiveFilters, labelsExcludedFromDashboard),
		refetchInterval: REFETCH_INTERVAL
	});
};
